
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policy/before-privacy-20260730",
      function () {
        return require("private-next-pages/policy/before-privacy-20260730.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policy/before-privacy-20260730"])
      });
    }
  